function parsearNumeroEntero(valor, nombre) {
  const texto = String(valor ?? '').trim()
  if (!/^-?\d+$/.test(texto)) {
    throw new Error(`El parámetro ${nombre} de contador debe ser un número entero`)
  }
  return Number(texto)
}

export function contador(identificador, inicio, paso, indice) {
  if (!String(identificador || '').trim()) {
    throw new Error('El primer parámetro de contador debe ser el identificador de una tabla o bloque')
  }

  if (indice == null || indice === '') {
    throw new Error('contador debe ser expandido por preproceso dentro de una tabla o repiteEstructura')
  }

  const indiceParseado = parsearNumeroEntero(indice, 'indice')
  const inicioParseado = parsearNumeroEntero(inicio, 'inicio')
  const pasoParseado = parsearNumeroEntero(paso, 'paso')

  const resultado = inicioParseado + (indiceParseado * pasoParseado)
  return String(resultado)
}
